module.exports = __webpack_public_path__ + "static/media/pu.f9dc5995.png";